import { RevisionHistoryDialogCtrl } from '../controllers/RevisionHistoryDialogCtrl';
import { IActionContext } from '../../ts/helpers/ActionContext';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { DatasourceContentType, FlowContentType, IContentType, WorkbookContentType } from '../../ts/models/ContentTypes';
import { DatasourceRevisionsInstance } from '../../revisionHistoryDatasource/resources/DatasourceRevisions';
import { FlowRevisions } from '../../revisionHistoryFlow/resources/FlowRevisions';
import { WorkbookRevisionsInstance } from '../../revisionHistoryWorkbook/resources/WorkbookRevisions';
import { IContentRevision } from '../serverApi/types/IContentRevision';
import { IWorkbookRevision } from '../../revisionHistoryWorkbook/serverApi/types/IWorkbookRevision';
import { FlowRevision } from '../../revisionHistoryFlow/serverApi/types/FlowRevision';
import { IDatasourceRevision } from '../../revisionHistoryDatasource/serverApi/types/IDatasourceRevision';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { Messages } from '../../codegen/Localize';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import {RevisionHistoryActionContext} from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';
import {FeatureFlags} from '~src/ts/FeatureFlags';


export namespace DeleteRevisionAction {
    // TODO: after turning on feature flag revisionHistoryDialogMigrationFF remove IActionContext
    export function showDeleteWorkbookRevisionDialog(revision: IWorkbookRevision, context: IActionContext | RevisionHistoryActionContext<any>): Promise<IResult> {
      return showDeleteRevisionDialog(revision, context, WorkbookContentType);
    }

    export function showDeleteDataSourceRevisionDialog(revision: IDatasourceRevision, context:  IActionContext | RevisionHistoryActionContext<any>): Promise<IResult> {
      return showDeleteRevisionDialog(revision, context, DatasourceContentType);
    }

    export function showDeleteFlowRevisionDialog(revision: FlowRevision, context:  IActionContext | RevisionHistoryActionContext<any>): Promise<IResult> {
      return showDeleteRevisionDialog(revision, context, FlowContentType);
    }

    function showDeleteRevisionDialog(revision: IContentRevision, context:  IActionContext | RevisionHistoryActionContext<any>, contentType: IContentType): Promise<IResult> {
      let successText: string;

      switch (contentType) {
        case WorkbookContentType:
          successText = Messages.deleteWorkbookRevisionSuccess();
          break;
        case DatasourceContentType:
          successText = Messages.deleteDataSourceRevisionSuccess();
          break;
        case FlowContentType:
          successText = Messages.deleteFlowRevisionSuccess();
          break;
        default:
          throw new Error(Messages.revisionHistoryUnsupportedContentType());
      }

      const dialogInstance = openReactConfirmationDialog<void, IResult>({
        dialogWidth: TabDialogWidth.width375px,
        title: Messages.deleteMessage(),
        message: Messages.deleteRevisionConfirm(),
        actionName: Messages.deleteMessage(),
        isActionDelete: true,
        paramsForAction: undefined,
        action: () => performDelete(revision, contentType, successText)
      });

      dialogInstance.result.then((result) => deselectDeletedRevision(result, revision, context), ()=>{});
      return Promise.resolve(dialogInstance.result);
    }

    export function performDelete(revision: IContentRevision, contentType: IContentType, successText: string): Promise<IResult> {
      let deleteRequest;
      switch (contentType) {
        case WorkbookContentType:
          deleteRequest = WorkbookRevisionsInstance.del;
          break;
        case DatasourceContentType:
          deleteRequest = DatasourceRevisionsInstance.del;
          break;
        case FlowContentType:
          deleteRequest = FlowRevisions.del;
          break;
        default:
          throw new Error(Messages.revisionHistoryUnsupportedContentType());
      }
      return deleteRequest(revision.id).then(
        (result: IResult) => {
          if (ResultHelper.hasErrors(result)) {
            ToasterService.instance.pop({ type: ToastType.Error, text: Messages.deleteRevisionError() });
          } else {
            ToasterService.instance.pop({ type: ToastType.Info, text: successText });
          }
          return Promise.resolve(result);
        }
      );
    }

    function deselectDeletedRevision(result: IResult, deletedRevision: IContentRevision, context: IActionContext | RevisionHistoryActionContext<any>) {
      if(FeatureFlags.revisionHistoryDialogMigrationFF) {
        if (!ResultHelper.hasErrors(result)){
          (context as RevisionHistoryActionContext<IContentRevision>).updateState();
        }
      }else{
        const revisionHistoryScope = (<RevisionHistoryDialogCtrl.Scope>(context as any as IActionContext).scope);
        if (deletedRevision.id === revisionHistoryScope.selectedItems.first().id) {
          revisionHistoryScope.selectedItems.remove(deletedRevision);
        }
      }
    }
}